export enum PowerType {
  AC_1_PHASE = 'ac1Phase',
  AC_3_PHASE = 'ac3Phase',
  DC = 'dc',
}
